// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemConfigurationCopySetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Input from 'share/components/controls/Izenda.Input';
import EventUtils from 'EventUtils';
import Panel from'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';

@connect()
export default class SystemConfigurationCopySetting extends Component {

  render() {
    const { store, permissionSetting } = this.props;
    const header = {
      title: 'System Configuration Copy Settings',
      icon: 'icon-toggle-triangle',
      className: 'u_noPaddingLeft u-bgGray'
     };
    return (
      <Panel
        id={this.props.id}
        header={header}
        className='header-section'
        collapsible
        expanedOption >
        <PanelBody store={store} permissionSetting={permissionSetting} />
      </Panel>
    );
  }
}

@connect()
class PanelBody extends Component {

  constructor(props: any) {
    super(props);

    const { store: { item } } = props;
    this.item = item;
  }

  onCopyEmailConfigurationChanged(value) {
    const item = this.item;
    item.copyEmailConfiguration = value;
    item.markDirty();
  }

  onCopyGoogleMapConfigurationChanged(value) {
    const item = this.item;
    item.copyGoogleMapConfiguration = value;
    item.markDirty();
  }

  onCopyReportConfigurationChanged(value) {
    const item = this.item;
    item.copyReportConfiguration = value;
    item.markDirty();
  }

  render() {
    const { store: { item }, localization } = this.props;
    const headerText = localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SELECT_SYSYEM_CONFIGURATION_TO_COPY');
    return (
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u-bgLightBlue u_paddingAll'>
          <span className='u_marginLeft'>{headerText}</span>
        </GridLayout.Row>
        <GridLayout.Row className='u_noMarginAll u_borderAll u_paddingAll'>
          <GridLayout.Col cols='12'>
            <GridLayout.Col cols='3'>
              <label>
                <Input type='checkbox'
                  checked={item.copyEmailConfiguration}
                  onChange={EventUtils.notifyChange(this.onCopyEmailConfigurationChanged.bind(this), EventUtils.CHECKBOX)}
                />
                <span>{localization.getText('CONTEXT_MENU_LABEL_EMAIL')}</span>
              </label>
            </GridLayout.Col>
            <GridLayout.Col cols='3'>
              <label>
                <Input type='checkbox'
                  checked={item.copyReportConfiguration}
                  onChange={EventUtils.notifyChange(this.onCopyReportConfigurationChanged.bind(this), EventUtils.CHECKBOX)}
                />
                <span>{localization.getText('CONTEXT_MENU_LABEL_REPORT')}</span>
              </label>
            </GridLayout.Col>
            <GridLayout.Col cols='3'>
              <label>
                <Input type='checkbox'
                  checked={item.copyGoogleMapConfiguration}
                  onChange={EventUtils.notifyChange(this.onCopyGoogleMapConfigurationChanged.bind(this), EventUtils.CHECKBOX)}
                />
                <span>{localization.getText('CONTEXT_MENU_LABEL_GOOGLE_MAP')}</span>
              </label>
            </GridLayout.Col>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SystemConfigurationCopy/Izenda.SystemConfigurationCopySetting.js